import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnMV: CultureInfo = {
  name: 'en-MV',
  displayName: 'English (Maldives)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-MV',
  parent: CultureInfoEn
};
